document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  var target = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!target) return;
  var expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  target.hidden = expanded;
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  var target = document.getElementById('MobileNav');
  var toggle = document.querySelector('[data-menu-toggle]');
  if (!target || target.hidden) return;
  target.hidden = true;
  if (toggle) {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  }
});

document.querySelectorAll('.mobile-nav a').forEach(function (link) {
  link.addEventListener('click', function () {
    var target = document.getElementById('MobileNav');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (target) target.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  });
});

document.addEventListener('change', function (event) {
  if (event.target.matches('[data-localization-select]')) {
    event.target.form.submit();
  }
  if (event.target.matches('[data-product-variant]')) {
    var option = event.target.options[event.target.selectedIndex];
    var form = event.target.closest('form');
    var button = form && form.querySelector('[data-add-to-cart]');
    if (button) {
      var available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
    }
  }
});

document.querySelectorAll('[data-countdown]').forEach(function (node) {
  var target = Date.parse(node.dataset.countdown || '');
  if (!Number.isFinite(target)) {
    node.hidden = true;
    return;
  }
  function render() {
    var remaining = target - Date.now();
    if (remaining <= 0) {
      node.textContent = node.dataset.expiredLabel || 'Campaign ended';
      return;
    }
    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor((remaining % 86400000) / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    node.textContent = days + 'd ' + hours + 'h ' + minutes + 'm';
    window.setTimeout(render, 60000);
  }
  render();
});

document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
  var slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
  var dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));
  var delay = Number(slider.dataset.autoplay || 0) * 1000;
  var active = 0;
  var timer;
  if (slides.length < 2) return;
  function show(index) {
    active = (index + slides.length) % slides.length;
    slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === active); });
    dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === active); });
  }
  function schedule() {
    window.clearInterval(timer);
    if (delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = window.setInterval(function () { show(active + 1); }, delay);
    }
  }
  dots.forEach(function (dot) { dot.addEventListener('click', function () { show(Number(dot.dataset.heroDot)); schedule(); }); });
  schedule();
});
